import GeneralInfoForm from "./js/GeneralInfoForm";
export default GeneralInfoForm;